import { render } from "./ChallengeMap.vue?vue&type=template&id=0512a519&scoped=true"
import script from "./ChallengeMap.vue?vue&type=script&lang=js"
export * from "./ChallengeMap.vue?vue&type=script&lang=js"

import "./ChallengeMap.vue?vue&type=style&index=0&id=0512a519&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0512a519"]])

export default __exports__